import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { leadKeys } from '@/lib/queryKeys';
import { leadEndpoints } from '@/lib/api/endpoints';
import { apiPost, operationsClient } from '@/lib/api';
import type { LeadStage, ReorderLeadStagesDto } from '@/types/lead';

export function useReorderLeadStages() {
  const queryClient = useQueryClient();

  return useApiMutation<LeadStage[], ReorderLeadStagesDto>({
    mutationFn: (dto) =>
      apiPost<LeadStage[], ReorderLeadStagesDto>(
        operationsClient,
        leadEndpoints.stagesReorder(),
        dto,
      ),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: leadKeys.stages() });
      void queryClient.invalidateQueries({ queryKey: leadKeys.pipeline() });
      toast.success('Lead stages reordered');
    },
  });
}
